import { autoinject, transient } from "aurelia-dependency-injection";
import { RightShipDialogServiceConstants } from "../../../../../../../../constants/basics/rightship-dialog.constants";
import { EntityTypes } from "@rightship-tech/common-ui/models/basic.models";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { VettingService } from "../../../../../../../../services/vetting/vetting.service";
import { BaseRedMarblePlugin } from "./base-red-marble";
import { Reflection } from "../../../../../../../../utilities/reflection";
import { computedFrom } from "aurelia-binding";

@autoinject
@transient()
export class Itf extends BaseRedMarblePlugin {

    constructor(private dialogClientService: DialogClientService,
        private vetService: VettingService) {
        super();
    }

    @computedFrom(Reflection.getPropertyPath<Itf>(z => z.data),
        Reflection.getPropertyPath<Itf>(z => z.data.data),
        Reflection.getPropertyPath<Itf>(z => z.data.data.inspections),
        Reflection.getPropertyPath<Itf>(z => z.data.data.inspections.length))
    get other() {
        if (!this.data || !this.data.data || this.data.data.inspections.length == 0)
            return null;
        return this.data.data.inspections;
    }

    editCurrentValues(){
        const entityType = EntityTypes.Vessel;
        this.dialogClientService.show(RightShipDialogServiceConstants.URLs.EditableEntityPropertyDialog, {
            entity: {
                entityType: entityType,
                vesselId: this.vet.vesselId,
                id: this.vet.vesselId
            },
            properties: ["HasItfAgreement","ItfAgreementDate"],
            refresh: (() => {
                this.vetService.getVetTasks(this.vet.vetId).then(x => {
                    this.vet.vetTasks = x;
                });
            }).bind(this)
        }, true, false, false, "right");
    }

    navigateToItfUrl(){
        window.open(`https://seafarers.oxfordwebapps.com/#/app/vessels/show/${this.vet.internationalMaritimeOrganizationNumber}`, '_blank').focus();
    }

    //     {
    //         "correlationId": "6358d9df-9922-4e14-a50b-c612b85dab87",
    //         "fallbackString": "A total of 2 agreements were found:\r\n\t[Live Agreement] From 2020-10-27 to 2021-10-26 of type IBF.\r\n\t[Expired Agreement] From 2019-10-27 to 2020-10-26 of type IBF.\r\n",
    //         "data": {
    //             "inspections": [
    //                 {
    //                     "vesselId": "34c021ef-8c63-e111-8b3a-128870ff3e6a",
    //                     "startDate": "2020-10-27T00:00:00Z",
    //                     "endDate": "2021-10-26T00:00:00Z",
    //                     "signatoryAffiliateGuid": "37c08a1b-5cb9-e011-b0d6-128870ff3e6a",
    //                     "signatoryAffiliate": "Norwegian Maritime Unions",
    //                     "signatoryUnion": "ASP Crew Management Services Ltd",
    //                     "status": "Live Agreement",
    //                     "type": "IBF",
    //                     "certificateNumber": "2015002073",
    //                     "certificateType": "Green",
    //                     "certificateStatus": "Y"
    //                 },
    //                 {
    //                     "vesselId": "34c021ef-8c63-e111-8b3a-128870ff3e6a",
    //                     "startDate": "2019-10-27T00:00:00Z",
    //                     "endDate": "2020-10-26T00:00:00Z",
    //                     "signatoryAffiliateGuid": "37c08a1b-5cb9-e011-b0d6-128870ff3e6a",
    //                     "signatoryAffiliate": "Norwegian Maritime Unions",
    //                     "signatoryUnion": "ASP Crew Management Services Ltd",
    //                     "status": "Expired Agreement",
    //                     "type": "IBF",
    //                     "certificateNumber": "2015002073",
    //                     "certificateType": "Green",
    //                     "certificateStatus": "N"
    //                 }
    //             ]
    //         }
    //    }

}